import { ApiBase } from '@/api/methods/ApiBase'
import { ApiResponseStudyGeneralLearning } from '@/api/responses/study/studyGeneralLearnings'

export namespace StudyGeneralLearningsApi {
  /**
   * 通常授業サポート学習の結果登録(学習進捗を進める)
   *
   * @param fixedExerciseId 固定問題ID
   * @param problemId 小問ID
   * @param questionInputs 設問解答情報(設問と解答欄単位の二次元配列)
   * @param startedUnixTime 演習開始時刻(UNIX時刻-秒)
   * @returns 登録結果
   */
  export async function postStudyGeneralLearningWithProgress(
    fixedExerciseId: number,
    problemId: number,
    questionInputs: string[][],
    startedUnixTime: number
  ): Promise<ApiResponseStudyGeneralLearning> {
    const params = {
      fixedExerciseId: fixedExerciseId,
      problemId: problemId,
      questionInputs: questionInputs,
      startedTimestamp: startedUnixTime,
    }
    return await ApiBase.post('/study/generalLearnings/progress', params)
  }

  /**
   * 通常授業サポート学習の結果登録(学習進捗を進めない)
   *
   * @param fixedExerciseId 固定問題ID
   * @param problemId 小問ID
   * @param questionInputs 設問解答情報(設問と解答欄単位の二次元配列)
   * @param startedUnixTime 演習開始時刻(UNIX時刻-秒)
   * @returns 登録結果
   */
  export async function postStudyGeneralLearning(
    fixedExerciseId: number,
    problemId: number,
    questionInputs: string[][],
    startedUnixTime: number
  ): Promise<ApiResponseStudyGeneralLearning> {
    const params = {
      fixedExerciseId: fixedExerciseId,
      problemId: problemId,
      questionInputs: questionInputs,
      startedTimestamp: startedUnixTime,
    }
    return await ApiBase.post('/study/generalLearnings', params)
  }
}
